import React from 'react'
import { PropTypes } from 'prop-types'
const BicycleIcon = (props) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.3 20.98"
    fill={props.fill ? props.fill : '#262626;'}
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
  >
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="m15.71,3.73c-.51,0-.95-.18-1.32-.55-.37-.37-.55-.8-.55-1.32s.18-.95.55-1.32c.37-.37.8-.55,1.32-.55s.95.18,1.32.55c.37.37.55.8.55,1.32s-.18.95-.55,1.32c-.37.37-.8.55-1.32.55Zm-5.04,5.27l2.28,2.43v6.32h-1.53v-5.12l-3.48-3.04c-.15-.14-.28-.32-.38-.55s-.15-.46-.15-.7.06-.47.17-.69.23-.4.37-.54l3.04-3.04c.14-.14.33-.26.58-.37s.51-.17.78-.17.53.06.78.17c.25.11.44.23.58.37l2,2c.46.46,1.01.86,1.65,1.19.64.33,1.36.5,2.16.5v1.53c-1.02,0-1.93-.19-2.76-.58-.82-.38-1.56-.9-2.21-1.55l-1.02-1.02-2.84,2.87Zm-5.68,2c1.41,0,2.6.48,3.55,1.43.96.96,1.43,2.14,1.43,3.56s-.48,2.6-1.43,3.55c-.96.96-2.14,1.43-3.56,1.43s-2.6-.48-3.55-1.43c-.96-.96-1.43-2.14-1.43-3.56s.48-2.6,1.43-3.55c.96-.96,2.14-1.43,3.56-1.43Zm0,8.72c1.06,0,1.94-.36,2.66-1.07.72-.72,1.07-1.6,1.07-2.66s-.36-1.94-1.07-2.66-1.6-1.07-2.66-1.07-1.94.36-2.66,1.07-1.07,1.6-1.07,2.66.36,1.94,1.07,2.66,1.6,1.07,2.66,1.07Zm14.33-8.72c1.41,0,2.6.48,3.55,1.43.96.96,1.43,2.14,1.43,3.56s-.48,2.6-1.43,3.55c-.96.96-2.14,1.43-3.56,1.43s-2.6-.48-3.55-1.43c-.96-.96-1.43-2.14-1.43-3.56s.48-2.6,1.43-3.55c.96-.96,2.14-1.43,3.56-1.43Zm0,8.72c1.06,0,1.94-.36,2.66-1.07.72-.72,1.07-1.6,1.07-2.66s-.36-1.94-1.07-2.66-1.6-1.07-2.66-1.07-1.94.36-2.66,1.07-1.07,1.6-1.07,2.66.36,1.94,1.07,2.66,1.6,1.07,2.66,1.07Z"
      />
    </g>
  </svg>
)

export default BicycleIcon
BicycleIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
